import {AvailableGig} from '@/types/gigs';
import {UserCampaignListItemDto} from '@/api/gigs/types';
import {mapUserCampaignListItemDtoToCollaborationGigBase} from '../common';

/**
 * Maps an available gig DTO from the API to the UI available gig model
 * @param dto The available gig DTO from the API
 * @returns The mapped available gig model for use in the UI
 */
export default function mapUserCampaignListItemDtoToAvailableGig(
  dto: UserCampaignListItemDto
): AvailableGig {
  return {
    type: 'available',
    ...mapUserCampaignListItemDtoToCollaborationGigBase(dto),
  };
}
